import {withSystem} from '@packages/systems/wfdl';
import {TList, TRecord, TText} from '@packages/systems/wfdl-ast';

// Pure wfdl Types for each collection list prop variant — no render-layer
// imports, so this package is safe to import from data-migration patches.
export const getCollectionListFilterPropType = () =>
  TRecord({
    filterFor: TText,
    fields: TList(
      TRecord({
        fieldPath: TText,
        operatorName: TText,
        // EE / localization: bindable Text. Number bindings wrap with
        // numberToText. DynamoWrapper omits this leaf so reify stays
        // naive for live Number / List[Text] JSON.
        value: withSystem({isBindable: true}, TText),
      })
    ),
  });

export const getCollectionListCuratedPropType = () =>
  TRecord({itemIds: TList(TText)});

export const getCollectionListSortPropType = () =>
  TList(
    TRecord({
      field: TText,
      direction: TText,
    })
  );
